import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    autorizacionDatos: [],
    transferenciaDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.autorizacionDatos = [];
        state.transferenciaDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.autorizacionDatos = params.autorizacionDatos;
        state.transferenciaDatos = params.transferenciaDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    getDatos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            if (params.transferenciaId) {
                apiAxios.get('eventos/' + params.eventoId + '/participante/' + params.participanteId + '/transferencia/' + params.transferenciaId) 
                    .then(res => {
                        let autorizacionDatos = [
                            { 'nombre': 'estado', 'campo': 'Estado', 'valor': res.data.estado, 'formato': '' },
                            { 'nombre': 'fechaAutorizacion', 'campo': 'Fecha Autorización', 'valor': res.data.fechaAutorizacion, 'formato': 'fecha' },
                            { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                            { 'nombre': 'cbu', 'campo': 'CBU/CVU', 'valor': res.data.cbu, 'formato': '' },
                            { 'nombre': 'cbuAlias', 'campo': 'CBU Alias', 'valor': res.data.cbuAlias, 'formato': '' },
                            { 'nombre': 'titularCuenta', 'campo': 'Titular', 'valor': res.data.titularCuenta, 'formato': '' },
                            { 'nombre': 'titularCuit', 'campo': 'CUIT', 'valor': res.data.titularCuit, 'formato': '' },
                            { 'nombre': 'importe', 'campo': 'Importe', 'valor': res.data.importe, 'formato': 'moneda' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                            { 'nombre': 'usuario', 'campo': 'Autorizó', 'valor': res.data.usuario, 'formato': '' }
                        ]

                        let transferenciaDatos = [];

                        if (moment(res.data.fechaTransferencia).format('YYYY-MM-DD') != '1900-01-01') {
                            transferenciaDatos.push(
                                { 'nombre': 'fechaTransferencia', 'campo': 'Fecha de Transferencia.', 'valor': res.data.fechaTransferencia, 'formato': 'fecha' },
                                { 'nombre': 'importeTransferido', 'campo': 'Transferido', 'valor': res.data.importeTransferido, 'formato': 'moneda' }
                            )
                            if ((/true/i).test(res.data.rechazada)) {
                                transferenciaDatos.push({ 'nombre': 'motivoRechazo', 'campo': 'Motivo Rechazo', 'valor': res.data.motivoRechazo, 'formato': '' })
                            }
                            transferenciaDatos.push({ 'nombre': 'usuarioTransferencia', 'campo': 'Actualizó Transferencia', 'valor': res.data.usuarioTransferencia, 'formato': '' })
                        }

                        let params = {
                            autorizacionDatos,
                            transferenciaDatos
                        }

                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}